import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';
import { RxTemplate } from '@shared/rx-templates/rx-template.model';
import { ProcedureMap } from '@shared/models/procedure-map';
import { ISectionDirtyCheckService } from '@shared/models/section-dirty-check';
import { ShellQuery } from '@shared/store/shell/shell-query';
import { DentureDetailsQuery } from '@modules/denture-details/state/denture-details.query';
import { DentureDetailsDirtyCheckService } from '@modules/denture-details/denture-details-dirty-check.service';
import { OrderQuery } from '@modules/order/state/order-query';
import { RxIntuitiveDentureVisibilityService } from './rx-intuitive-denture-visibility.service';

@Injectable({ providedIn: 'root' })
export class RxIntuitiveDentureDirtyCheckService implements ISectionDirtyCheckService {
	constructor(
		private readonly query: DentureDetailsQuery,
		private readonly orderQuery: OrderQuery,
		private readonly visibilityService: RxIntuitiveDentureVisibilityService,
		private readonly shellQuery: ShellQuery
	) {}

	willLoseDataFor$(targetTemplate: Readonly<RxTemplate>, targetProcedureMap: ProcedureMap | null): Observable<boolean> {
		return this.visibilityService.fieldsFor$(targetTemplate, targetProcedureMap).pipe(
			withLatestFrom(this.visibilityService.fields$, this.visibilityService.isSectionVisible$),
			map(([tgt, cur, isVisible]) => {
				if (!isVisible) {
					return false;
				}

				const s = this.query.getValue();

				return (
					(cur.procedureType && !tgt.procedureType && this.orderQuery.hasProcedureTypeId) ||
					DentureDetailsDirtyCheckService.checkBaseFields(tgt, cur, s, this.shellQuery.defaultShadeSystemId)
				);
			})
		);
	}
}
